"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var financeApplication = {
    START: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation StartFinanceApplication($dealId: String!) {\n      startFinanceApplication(dealId: $dealId) {\n        code\n      }\n    }\n  "], ["\n    mutation StartFinanceApplication($dealId: String!) {\n      startFinanceApplication(dealId: $dealId) {\n        code\n      }\n    }\n  "]))),
};
exports.default = financeApplication;
var templateObject_1;
